import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import { queryClient } from "@/lib/queryClient";
import { bulkDeleteRiskAnalysis } from "@/api/endpoints/riskAnalysis";
import type {
  BulkDeleteRiskAnalysisRequest,
  BulkDeleteRiskAnalysisResponse,
} from "@/api/types/riskAnalysis";

export function useBulkDeleteRiskAnalysis(): UseMutationResult<
  BulkDeleteRiskAnalysisResponse,
  Error,
  BulkDeleteRiskAnalysisRequest,
  unknown
> {
  return useMutation({
    mutationFn: bulkDeleteRiskAnalysis,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["riskAnalysis", "history"],
      });
      queryClient.invalidateQueries({
        queryKey: ["riskAnalysis"],
      });
    },
  });
}
